import { IFareSelectorsBoolean } from '../../../types';
import { FareRequest } from '../../../client/src';

export const determineSelectorErrors = ({
  touchedFields,
  invalidFields,
  values,
}: {
  touchedFields: IFareSelectorsBoolean;

  invalidFields: IFareSelectorsBoolean;
  values: Partial<FareRequest>;
}) => {
  const isCustomerTypeRequiredError =
    touchedFields.customerType && !values.customerType;
  const isZoneRequiredError = touchedFields.zone && !values.zone;
  const isTravelMethodRequiredError =
    touchedFields.travelMethod && !values.travelMethod;
  const isTravelTimeRequiredError =
    touchedFields.travelTime && !values.travelTime;

  let zoneErrorOptions = '';
  const isZoneError = isZoneRequiredError || invalidFields.zone;
  if (isZoneError) {
    zoneErrorOptions = isZoneRequiredError
      ? 'travel_zone_error_options'
      : 'travel_zone_error_no_longer_valid';
  }

  let travelMethodOptions = '';
  const isTravelMethodError =
    isTravelMethodRequiredError || invalidFields.travelMethod;
  if (isTravelMethodError) {
    travelMethodOptions = isTravelMethodRequiredError
      ? 'travel_method_error_options'
      : 'travel_method_error_no_longer_valid';
  }

  let travelTimeOptions = '';
  const isTravelTimeError =
    isTravelTimeRequiredError || invalidFields.travelTime;
  if (isTravelTimeError) {
    travelTimeOptions = isTravelTimeRequiredError
      ? 'travel_time_error_options'
      : 'travel_time_error_no_longer_valid';
  }

  return {
    customerType: {
      title: isCustomerTypeRequiredError ? 'customer_type_error_title' : '',
      options: isCustomerTypeRequiredError ? 'customer_type_error_options' : '',
    },
    zone: {
      title: isZoneError ? 'travel_zone_error_title' : '',
      options: zoneErrorOptions,
    },
    travelMethod: {
      title: isTravelMethodError ? 'travel_method_error_title' : '',
      options: travelMethodOptions,
    },
    travelTime: {
      title: isTravelTimeError ? 'travel_time_error_title' : '',
      options: travelTimeOptions,
    },
  };
};
